import { SharedModule } from '../shared.module';
import { AccountAttributesEnum } from '../enums';
import { UserService } from '../../core/services/user.service';

export function HasAccess(attributes: AccountAttributesEnum | AccountAttributesEnum[], every?: boolean): Function {
    return function (target: Record<string, unknown>, propertyKey: string): void {
        const userServiceInstance: UserService = SharedModule?.injector.get(UserService);

        Object.defineProperty(target, propertyKey, {
            value: userServiceInstance?.hasAccessAsync(attributes, every),
        });
    };
}
